import React from 'react';

interface IMailProps {
  fill: string;
}

const CheckCircle = ({ fill = '', ...props }: IMailProps) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2282_52619"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="17"
    >
      <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2282_52619)">
      <path
        d="M6.9638 11.5663L11.6638 6.86634L10.7305 5.93301L6.9638 9.69967L5.0638 7.79967L4.13047 8.73301L6.9638 11.5663ZM7.89713 15.1663C6.97491 15.1663 6.10825 14.9913 5.29713 14.6413C4.48602 14.2913 3.78047 13.8163 3.18047 13.2163C2.58047 12.6163 2.10547 11.9108 1.75547 11.0997C1.40547 10.2886 1.23047 9.4219 1.23047 8.49967C1.23047 7.57745 1.40547 6.71079 1.75547 5.89967C2.10547 5.08856 2.58047 4.38301 3.18047 3.78301C3.78047 3.18301 4.48602 2.70801 5.29713 2.35801C6.10825 2.00801 6.97491 1.83301 7.89713 1.83301C8.81936 1.83301 9.68602 2.00801 10.4971 2.35801C11.3082 2.70801 12.0138 3.18301 12.6138 3.78301C13.2138 4.38301 13.6888 5.08856 14.0388 5.89967C14.3888 6.71079 14.5638 7.57745 14.5638 8.49967C14.5638 9.4219 14.3888 10.2886 14.0388 11.0997C13.6888 11.9108 13.2138 12.6163 12.6138 13.2163C12.0138 13.8163 11.3082 14.2913 10.4971 14.6413C9.68602 14.9913 8.81936 15.1663 7.89713 15.1663ZM7.89713 13.833C9.38602 13.833 10.6471 13.3163 11.6805 12.283C12.7138 11.2497 13.2305 9.98856 13.2305 8.49967C13.2305 7.01079 12.7138 5.74967 11.6805 4.71634C10.6471 3.68301 9.38602 3.16634 7.89713 3.16634C6.40825 3.16634 5.14714 3.68301 4.1138 4.71634C3.08047 5.74967 2.5638 7.01079 2.5638 8.49967C2.5638 9.98856 3.08047 11.2497 4.1138 12.283C5.14714 13.3163 6.40825 13.833 7.89713 13.833Z"
        fill="#00A331"
      />
    </g>
  </svg>
);

export default CheckCircle;
